// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as N_RnrErrorConfig from "../domain/store/N_RnrErrorConfig.bs.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as N_RnrVernacularHelper from "../domain/helper/N_RnrVernacularHelper.bs.js";

function getRoute(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "rnr") {
    return ;
  }
  var match$1 = match.tl;
  if (!match$1) {
    return ;
  }
  if (match$1.hd !== "2w") {
    return ;
  }
  var match$2 = match$1.tl;
  if (!match$2) {
    return ;
  }
  if (match$2.tl) {
    return ;
  }
  var url_params = UrlUtils$Catalyst.getURLParams(url.search);
  var version = Belt_Option.mapWithDefault(Js_dict.get(url_params, "version_name"), "", (function (x) {
          return x;
        }));
  var version_code = Belt_Option.mapWithDefault(Js_dict.get(url_params, "version_code"), "", (function (x) {
          return x;
        }));
  var match$3 = Js_dict.get(url_params, "auth_token");
  Belt_Option.getWithDefault(Js_dict.get(url_params, "vehicle_category"), "") === "2w";
  if (match$3 !== undefined) {
    return {
            TAG: /* N_RnrDashboard */1,
            _0: match$2.hd,
            _1: match$3,
            _2: N_RnrVernacularHelper.getLanguage(url_params),
            _3: version,
            _4: version_code
          };
  } else {
    return {
            TAG: /* DefaultErrorView */8,
            _0: N_RnrErrorConfig.authError
          };
  }
}

export {
  getRoute ,
  
}
/* N_RnrVernacularHelper Not a pure module */
